import Head from 'next/head'
import configuration from '~/configuration'

const GoogleTagManagementPublic = () => {
  if (configuration.production === false) return null

  return (
    <Head>
      <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MLR6F82X');`}</script>
    </Head>
  )
}

export default GoogleTagManagementPublic
